import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  HUBSPOT_CATEGORIES,
  HUBSPOT_SCRATCH_TEMPLATE,
  HUBSPOT_TEMPLATES,
} from './hubspotTemplates.const';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionTemplateGallery } from '@/Domain/components/Action/ActionTemplateGallery/ActionTemplateGallery';
import { HubSpotIcon } from '@/Domain/components/icons/HubSpot.icon';
import { useHubSpotTokenStatus } from '@/Domain/hooks/Integration/useHubSpotTokenStatus.hook';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

export const HubSpotTemplateGalleryDialog = () => {
  const { isOpen } = useModalStore();

  if (!isOpen(MODAL_NAMES.HUBSPOT_TEMPLATE_GALLERY_DIALOG)) return null;

  return <HubSpotTemplateGalleryDialogContent />;
};

const HubSpotTemplateGalleryDialogContent = () => {
  const { t } = useTranslation('actions_page');
  const { data: hubSpotStatus } = useHubSpotTokenStatus();

  const hubspotOauthMutation = useMutation<{ url: string }>({
    mutationKey: [QueryKey.integration.hubspotOauthMutation],
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });

  return (
    <ActionTemplateGallery
      testIdPrefix="hubspot"
      headerIcon={<HubSpotIcon className="size-5" />}
      titleKey="hubspot_templates.title"
      descriptionKey="hubspot_templates.description"
      categories={HUBSPOT_CATEGORIES}
      templates={HUBSPOT_TEMPLATES}
      scratchTemplate={HUBSPOT_SCRATCH_TEMPLATE}
      scratchLabelKey="hubspot_templates.start_from_scratch"
      scratchDescriptionKey="hubspot_templates.start_from_scratch_description"
      actionIcon="FaHubspot"
      actionIconColor="#EF4444"
      isConnected={Boolean(hubSpotStatus?.has_token)}
      connectionWarning={
        <div className="flex flex-wrap items-center justify-between gap-2">
          <p className="min-w-0 flex-1">{t('hubspot_templates.connection_warning')}</p>
          <button
            type="button"
            onClick={() => hubspotOauthMutation.mutate()}
            disabled={hubspotOauthMutation.isPending}
            data-testid="hubspot-connect-button"
            className="shrink-0 cursor-pointer rounded-sm font-medium text-warning underline decoration-warning/40 underline-offset-4 transition-colors hover:decoration-warning focus:outline-none focus-visible:ring-2 focus-visible:ring-warning/50 focus-visible:ring-offset-2 focus-visible:ring-offset-warning-muted disabled:opacity-60"
          >
            {t('hubspot_templates.connect_hubspot')}
          </button>
        </div>
      }
    />
  );
};
